import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { TeamPagePrefetchedDataProps } from 'src/app/pages/about/team/pageContext';
import { prefetchPageContext, TeamPageContextProvider } from 'src/app/pages/about/team/pageContext';

import { Layout } from '../layout';

import { TeamErrorHandler } from './ErrorHandler';

export const Team = withPrefetchedData(
	function Team({ prefetchedData }: TeamPagePrefetchedDataProps): JSX.Element {
		return (
			<TeamPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TeamErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</TeamPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
